<template>
    <footer>
        <!--SM et - -->
        <v-container fluid class="hidden-md-and-up mb-10">
            <!--            <mobile-footer-menu data-testid="mobile-footer-menu" />-->
            <v-flex v-if="getFooterInfo" xs12 py-4>
                <v-layout row wrap>
                    <v-flex sm1 xs2>
                        <img
                            :src="getClientLogomark ? getClientLogomark : getLogoUrl"
                            alt="Logo"
                            style="max-width: 48px;" />
                    </v-flex>
                    <v-flex xs10 sm11 class="">
                        <p v-if="getEstablishment.name" class="title">
                            {{ getEstablishment.name }}
                        </p>
                        <p v-if="getEstablishment.address" class="subheading">
                            {{ getEstablishment.address }}
                        </p>
                        <p v-if="getEstablishment.phone" class="subheading">
                            {{ formatNanpPhoneNumber(getEstablishment.phone) }}
                        </p>
                        <p v-if="getEstablishment.fax" class="subheading">
                            {{ formatNanpPhoneNumber(getEstablishment.fax) }}
                        </p>
                        <p v-if="getEstablishment.website" class="subheading">
                            <a :href="getEstablishment.website" target="_blank">
                                {{ $t('footer.website') }}
                            </a>
                        </p>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-if="publicPageFooterText" class="pb-4 xs12 text-center caption wysiwyg-output" v-html="publicPageFooterText" />
            <v-flex class="xs12 text-center caption">
                {{ $t('footer.trimoz.clicsante') }}
            </v-flex>
        </v-container>
        <!-- MD et + -->
        <v-container fluid class="hidden-sm-and-down">
            <v-flex sm12 pb-12>
                <v-layout row wrap>
                    <v-flex v-if="getFooterInfo" sm12>
                        <v-layout row justify-space-between>
                            <v-flex sm2 my-auto class="text-right">
                                <img
                                    class="logo-footer mr-4"
                                    width="150px"
                                    style="max-width: 96px;"
                                    :src="getClientLogomark ? getClientLogomark : getLogoUrl"
                                    alt="Logo" />
                            </v-flex>

                            <v-flex sm6 my-auto>
                                <p v-if="getEstablishment.name" class="title">
                                    {{ getEstablishment.name }}
                                </p>
                                <p v-if="getEstablishment.address" class="subheading">
                                    {{ getEstablishment.address }}
                                </p>
                                <p v-if="getEstablishment.phone" class="subheading">
                                    {{ $t('base.phonePrefix') }} {{ formatNanpPhoneNumber(getEstablishment.phone) }}
                                </p>
                                <p v-if="getEstablishment.fax" class="subheading">
                                    {{ $t('base.faxPrefix') }} {{ formatNanpPhoneNumber(getEstablishment.fax) }}
                                </p>
                                <p v-if="getEstablishment.website" class="subheading">
                                    <a :href="getEstablishment.website" target="_blank">
                                        {{ $t('footer.website') }}
                                    </a>
                                </p>
                            </v-flex>
                            <v-flex sm4 my-auto text-right>
                                <img
                                    v-if="getStyle === 'pharmaservices'"
                                    class="logo-footer"
                                    alt="Logo"
                                    style="max-width: 96px;"
                                    :src="getFooterProductLogo" />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex v-else sm6 />
                </v-layout>
            </v-flex>
            <v-flex v-if="publicPageFooterText" class="pb-4 sm12 text-center caption wysiwyg-output" v-html="publicPageFooterText" />
            <v-flex class="sm12 text-center caption">
                <span v-if="getStyle === 'pharmaservices'">
                    {{ $t('footer.trimoz.pharmaservices') }}
                </span>
                <span v-else-if="getStyle === 'pharmaprix'">
                    {{ $t('footer.trimoz.pharmaprix') }}
                </span>
                <span v-else-if="getStyle === 'uniprix'">
                    {{ $t('footer.trimoz.uniprix') }}
                </span>
                <span v-else>
                    {{ $t('footer.trimoz.clicsante') }}
                </span>
            </v-flex>
        </v-container>
        <v-layout row wrap justify-center class="grey darken-3 bottom-footer">
            <v-flex
                flex
                xs12
                text-center
                d-flex
                align-center
                justify-center
                white--text
                body-2
            >
                <ul id="usersMenus">
                    <li v-for="(menu, index) in usersMenus" class="py-2 d-inline" :key="index">
                        <a :href="menu.href" :target="menu.target" class="white--text" v-text="menu.title" />
                        <span v-if="index !== usersMenus.length - 1" class="px-3 white--text">
                            |
                        </span>
                    </li>
                </ul>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center class="grey darken-3 bottom-footer">
            <v-flex
                flex
                xs12
                text-center
                d-flex
                align-center
                justify-center
                white--text
                body-2
            >
                <span class="mx-auto">
                    &copy; {{ getCurrentYear }} - Trimoz Technologies - {{ $t('footer.trimoz.allRightsReserved') }}
                </span>
                <v-img
                    v-if="isClicSante"
                    :src="getFooterProductLogo"
                    style="float: right;  max-width: 40px; max-height: 40px; margin-right: 10px;" />
            </v-flex>
        </v-layout>
    </footer>
</template>

<script>
// import MobileFooterMenu from '@/components/bars/mobileFooterMenu/MobileFooterMenu';
import { format } from 'date-fns';
import { formatPhoneNumber } from '@/utils';
import { format as formatNanpPhoneNumber } from '@/formatters/phone/nanp';
import { EstablishmentSetting } from '@/enums';
import { mapGetters } from 'vuex';
import { inferPortalUrl } from '@/helpers/env';
export default {
    name: 'app-footer',
    components: {
        // MobileFooterMenu,
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            getStyle: 'getStyle',
            isClicSante: 'isClicSante',
            getStaticFilesUrl: 'getStaticFilesUrl',
            getEstablishmentSettingById: 'establishment/getEstablishmentSettingById',
            getEstablishment: 'establishment/getEstablishment',
            getTexts: 'texts/getTexts',
            getLogoUrl: 'getLogoUrl',
        }),
        publicPageFooterText() {
            const texts = this.getTexts;
            if (texts[this.locale].publicPageFooter) {
                return texts[this.locale].publicPageFooter;
            }
            return '';
        },
        getCurrentYear() {
            return format(new Date(), 'YYYY');
        },
        getClientLogomark() {
            if (this.getEstablishmentSettingById(EstablishmentSetting['USE_CLIENT_LOGO']) &&
                this.getEstablishmentSettingById(EstablishmentSetting['CLIENT_LOGOMARK'])) {
                return this.getEstablishmentSettingById(EstablishmentSetting['CLIENT_LOGOMARK']);
            }
            return false;
        },
        getFooterInfo() {
            return this.getEstablishmentSettingById(EstablishmentSetting['ENABLE_FOOTER_INFO']);
        },
        getFooterProductLogo() {
            return this.getStaticFilesUrl + `/images/logo_footer.png`;
        },
        usersMenus() {
            return [
                {
                    title: this.$t('footer.terms.name'),
                    href: inferPortalUrl() + '/' + this.$t('footer.terms.path'),
                    target: '_blank'
                },
                {
                    title: this.$t('footer.policy.name'),
                    href: inferPortalUrl() + '/' + this.$t('footer.policy.path'),
                    target: '_blank'
                },
                {
                    title: this.$t('footer.cookiePolicy.name'),
                    href: inferPortalUrl() + '/' + this.$t('footer.cookiePolicy.path'),
                    target: '_blank'
                }
            ];
        }
    },
    methods: {
        formatPhoneNumber(val) {
            return formatPhoneNumber(val);
        },
        formatNanpPhoneNumber(val) {
            return formatNanpPhoneNumber(val, this.locale);
        },
    },
};
</script>

<style lang="scss">
footer {
    font-size: 12px;

    .footer-banner {
        min-height: auto;
        background-size: cover;
        background: #FFF url("../../../public/img/footer-background.png") center center no-repeat;

    }

    .bottom-footer {
        height: 50px;
    }
}
</style>
